export enum PublicPagesSections {
  Waitlist = 'waitlist',
  Bookings = 'bookings',
  Footer = 'footer',
  Closed = 'closed',
}
